/** @flow */
import { Map } from 'immutable';


export default function renderUnitCell(address) {
  return address.get('unitNumber', '');
}
